import React from "react";
import { differenceInDays, format } from "date-fns";

interface IStayDatesFooterProps {
  checkIn: Date | string | null;
  checkOut: Date | string | null;
  onDone: () => void;
  label?: string;
}

/**
 * The foot of the app's select date screen (`SelectDatePage`): "Check In | N Days | Check
 * Out" over a pink button, which waits for the check-out once a check-in is picked. Sits
 * in a footer with the app's `#C3C6D3` line above it.
 */
const StayDatesFooter: React.FC<IStayDatesFooterProps> = ({
  checkIn,
  checkOut,
  onDone,
  label = "Done",
}) => {
  const days =
    checkIn && checkOut
      ? Math.max(0, differenceInDays(new Date(checkOut), new Date(checkIn)))
      : 0;
  return (
    <>
      <div className="mb-4 flex items-center">
        <div className="flex-1">
          <p className="text-12 text-ink-gray">Check In</p>
          <p className="text-16 text-ink-black">
            {checkIn ? format(new Date(checkIn), "dd MMM, yyyy") : "Check In"}
          </p>
        </div>
        <div className="flex flex-1 justify-center">
          {/* On desktop the count is bolder, on a light pink tile, to read at a glance. */}
          <p className="flex flex-col items-center rounded-lg border border-[#F5F5F5] px-6 py-2 text-center text-12 leading-4 text-brand md:border-brand/30 md:bg-[#FFF5F8] md:px-7">
            <span className="md:text-20 md:font-bold md:leading-6">{days}</span>
            <span className="md:text-13 md:font-semibold">
              {days > 1 ? "Days" : "Day"}
            </span>
          </p>
        </div>
        <div className="flex-1 text-center">
          <p className="text-12 text-ink-gray">Check Out</p>
          <p className="text-16 text-ink-black">
            {checkOut
              ? format(new Date(checkOut), "dd MMM, yyyy")
              : "Check Out"}
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={onDone}
        disabled={!!checkIn && !checkOut}
        className="flex h-14 w-full items-center justify-center rounded-lg bg-brand text-16 text-white active:opacity-80 disabled:opacity-50"
      >
        {label}
      </button>
    </>
  );
};

export default StayDatesFooter;
